import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Roundabout Rules questions
export const roundaboutRulesMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-rr-1',
    text: {
      en: 'According to Dutch traffic rules, you are approaching a roundabout. What should you do before entering?',
      nl: 'Volgens de Nederlandse verkeersregels nader je een rotonde. Wat moet je doen voordat je binnenrijdt?',
      ar: 'وفقا لقواعد المرور الهولندية، أنت تقترب من دوار. ماذا يجب أن تفعل قبل الدخول؟'
    },
    options: [
      {
        id: 'q-rr-1o1',
        text: {
          en: 'Give way to traffic already in the roundabout',
          nl: 'Geef voorrang aan verkeer dat al op de rotonde rijdt',
          ar: 'أعط الأولوية للمرور الموجود بالفعل في الدوار'
        }
      },
      {
        id: 'q-rr-1o2',
        text: {
          en: 'Enter immediately if no cars are visible',
          nl: 'Rijd onmiddellijk binnen als er geen auto\'s zichtbaar zijn',
          ar: 'ادخل فورا إذا لم تكن هناك سيارات مرئية'
        }
      },
      {
        id: 'q-rr-1o3',
        text: {
          en: 'Stop completely before entering',
          nl: 'Stop volledig voordat je binnenrijdt',
          ar: 'توقف تماما قبل الدخول'
        }
      }
    ],
    correctAnswerId: 'q-rr-1o1',
    explanation: {
      en: 'Dutch traffic law requires you to give way to traffic already in the roundabout, including cyclists and pedestrians, before entering.',
      nl: 'De Nederlandse verkeerswet vereist dat je voorrang verleent aan verkeer dat al op de rotonde rijdt, inclusief fietsers en voetgangers, voordat je binnenrijdt.',
      ar: 'يتطلب قانون المرور الهولندي إعطاء الأولوية للمرور الموجود بالفعل في الدوار، بما في ذلك راكبو الدراجات والمشاة، قبل الدخول.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-2',
    text: {
      en: 'According to Dutch traffic rules, you are in a roundabout and want to exit. What should you do?',
      nl: 'Volgens de Nederlandse verkeersregels ben je op een rotonde en wil je uitrijden. Wat moet je doen?',
      ar: 'وفقا لقواعد المرور الهولندية، أنت في دوار وتريد الخروج. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-2o1',
        text: {
          en: 'Signal right before exiting',
          nl: 'Geef richting aan rechts voordat je uitrijdt',
          ar: 'أشر يمينا قبل الخروج'
        }
      },
      {
        id: 'q-rr-2o2',
        text: {
          en: 'Signal left before exiting',
          nl: 'Geef richting aan links voordat je uitrijdt',
          ar: 'أشر يسارا قبل الخروج'
        }
      },
      {
        id: 'q-rr-2o3',
        text: {
          en: 'No need to signal when exiting',
          nl: 'Geen richtingaanwijzer nodig bij uitrijden',
          ar: 'لا حاجة للإشارة عند الخروج'
        }
      }
    ],
    correctAnswerId: 'q-rr-2o1',
    explanation: {
      en: 'Dutch traffic law requires you to signal right when exiting a roundabout to indicate your intention to leave.',
      nl: 'De Nederlandse verkeerswet vereist dat je rechts richting aangeeft wanneer je een rotonde verlaat om je voornemen om te vertrekken aan te geven.',
      ar: 'يتطلب قانون المرور الهولندي الإشارة يمينا عند الخروج من الدوار للإشارة إلى نيتك في المغادرة.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-3',
    text: {
      en: 'You are approaching a roundabout and want to turn left. Which lane should you use?',
      nl: 'Je nadert een rotonde en wilt linksaf slaan. Welke rijstrook moet je gebruiken?',
      ar: 'أنت تقترب من دوار وتريد الانعطاف يسارا. أي ممر يجب أن تستخدم؟'
    },
    options: [
      {
        id: 'q-rr-3o1',
        text: {
          en: 'Left lane',
          nl: 'Linker rijstrook',
          ar: 'الممر الأيسر'
        }
      },
      {
        id: 'q-rr-3o2',
        text: {
          en: 'Right lane',
          nl: 'Rechter rijstrook',
          ar: 'الممر الأيمن'
        }
      },
      {
        id: 'q-rr-3o3',
        text: {
          en: 'Either lane is acceptable',
          nl: 'Beide rijstroken zijn acceptabel',
          ar: 'أي ممر مقبول'
        }
      }
    ],
    correctAnswerId: 'q-rr-3o1',
    explanation: {
      en: 'When turning left at a roundabout, use the left lane to enter and stay in the left lane while in the roundabout.',
      nl: 'Bij linksaf slaan op een rotonde gebruik je de linker rijstrook om binnen te rijden en blijf je in de linker rijstrook terwijl je op de rotonde rijdt.',
      ar: 'عند الانعطاف يسارا عند الدوار، استخدم الممر الأيسر للدخول وابق في الممر الأيسر أثناء وجودك في الدوار.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-4',
    text: {
      en: 'You are approaching a roundabout and want to go straight ahead. Which lane should you use?',
      nl: 'Je nadert een rotonde en wilt rechtdoor gaan. Welke rijstrook moet je gebruiken?',
      ar: 'أنت تقترب من دوار وتريد المضي مباشرة. أي ممر يجب أن تستخدم؟'
    },
    options: [
      {
        id: 'q-rr-4o1',
        text: {
          en: 'Left lane',
          nl: 'Linker rijstrook',
          ar: 'الممر الأيسر'
        }
      },
      {
        id: 'q-rr-4o2',
        text: {
          en: 'Right lane',
          nl: 'Rechter rijstrook',
          ar: 'الممر الأيمن'
        }
      },
      {
        id: 'q-rr-4o3',
        text: {
          en: 'Either lane is acceptable',
          nl: 'Beide rijstroken zijn acceptabel',
          ar: 'أي ممر مقبول'
        }
      }
    ],
    correctAnswerId: 'q-rr-4o3',
    explanation: {
      en: 'When going straight ahead at a roundabout, you can use either lane unless road markings indicate otherwise.',
      nl: 'Bij rechtdoor gaan op een rotonde kun je beide rijstroken gebruiken, tenzij wegmarkeringen anders aangeven.',
      ar: 'عند المضي مباشرة عند الدوار، يمكنك استخدام أي ممر ما لم تشير علامات الطريق إلى خلاف ذلك.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-5',
    text: {
      en: 'You are approaching a roundabout and want to turn right. Which lane should you use?',
      nl: 'Je nadert een rotonde en wilt rechtsaf slaan. Welke rijstrook moet je gebruiken?',
      ar: 'أنت تقترب من دوار وتريد الانعطاف يمينا. أي ممر يجب أن تستخدم؟'
    },
    options: [
      {
        id: 'q-rr-5o1',
        text: {
          en: 'Left lane',
          nl: 'Linker rijstrook',
          ar: 'الممر الأيسر'
        }
      },
      {
        id: 'q-rr-5o2',
        text: {
          en: 'Right lane',
          nl: 'Rechter rijstrook',
          ar: 'الممر الأيمن'
        }
      },
      {
        id: 'q-rr-5o3',
        text: {
          en: 'Either lane is acceptable',
          nl: 'Beide rijstroken zijn acceptabel',
          ar: 'أي ممر مقبول'
        }
      }
    ],
    correctAnswerId: 'q-rr-5o2',
    explanation: {
      en: 'When turning right at a roundabout, use the right lane to enter and stay in the right lane while in the roundabout.',
      nl: 'Bij rechtsaf slaan op een rotonde gebruik je de rechter rijstrook om binnen te rijden en blijf je in de rechter rijstrook terwijl je op de rotonde rijdt.',
      ar: 'عند الانعطاف يمينا عند الدوار، استخدم الممر الأيمن للدخول وابق في الممر الأيمن أثناء وجودك في الدوار.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-6',
    text: {
      en: 'You are in a roundabout and want to change lanes. What should you do?',
      nl: 'Je bent op een rotonde en wilt van rijstrook wisselen. Wat moet je doen?',
      ar: 'أنت في دوار وتريد تغيير الممر. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-6o1',
        text: {
          en: 'Signal and change lanes when safe',
          nl: 'Geef richting aan en wissel van rijstrook wanneer het veilig is',
          ar: 'أشر وغير الممر عندما يكون آمنا'
        }
      },
      {
        id: 'q-rr-6o2',
        text: {
          en: 'Change lanes immediately',
          nl: 'Wissel onmiddellijk van rijstrook',
          ar: 'غير الممر فورا'
        }
      },
      {
        id: 'q-rr-6o3',
        text: {
          en: 'Never change lanes in a roundabout',
          nl: 'Wissel nooit van rijstrook op een rotonde',
          ar: 'لا تغير الممر أبدا في الدوار'
        }
      }
    ],
    correctAnswerId: 'q-rr-6o1',
    explanation: {
      en: 'You can change lanes in a roundabout, but you must signal your intention and only change when it is safe to do so.',
      nl: 'Je kunt van rijstrook wisselen op een rotonde, maar je moet je voornemen aangeven en alleen wisselen wanneer het veilig is om dat te doen.',
      ar: 'يمكنك تغيير الممر في الدوار، لكن يجب عليك الإشارة إلى نيتك وتغيير الممر فقط عندما يكون ذلك آمنا.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-7',
    text: {
      en: 'You are approaching a roundabout and see a cyclist already in the roundabout. What should you do?',
      nl: 'Je nadert een rotonde en ziet een fietser die al op de rotonde rijdt. Wat moet je doen?',
      ar: 'أنت تقترب من دوار وترى راكب دراجة موجودا بالفعل في الدوار. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-7o1',
        text: {
          en: 'Give way to the cyclist',
          nl: 'Geef voorrang aan de fietser',
          ar: 'أعط الأولوية لراكب الدراجة'
        }
      },
      {
        id: 'q-rr-7o2',
        text: {
          en: 'Enter the roundabout, cyclists must give way',
          nl: 'Rijd de rotonde op, fietsers moeten voorrang verlenen',
          ar: 'ادخل الدوار، يجب على راكبي الدراجات إعطاء الأولوية'
        }
      },
      {
        id: 'q-rr-7o3',
        text: {
          en: 'Honk to warn the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتحذير راكب الدراجة'
        }
      }
    ],
    correctAnswerId: 'q-rr-7o1',
    explanation: {
      en: 'Cyclists in a roundabout have the same rights as other vehicles. You must give way to them before entering.',
      nl: 'Fietsers op een rotonde hebben dezelfde rechten als andere voertuigen. Je moet hen voorrang verlenen voordat je binnenrijdt.',
      ar: 'راكبو الدراجات في الدوار لديهم نفس الحقوق مثل المركبات الأخرى. يجب عليك إعطاء الأولوية لهم قبل الدخول.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-8',
    text: {
      en: 'You are in a roundabout and see a pedestrian waiting to cross at an exit. What should you do?',
      nl: 'Je bent op een rotonde en ziet een voetganger die wacht om over te steken bij een uitgang. Wat moet je doen?',
      ar: 'أنت في دوار وترى أحد المشاة ينتظر العبور عند مخرج. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-8o1',
        text: {
          en: 'Give way to the pedestrian',
          nl: 'Geef voorrang aan de voetganger',
          ar: 'أعط الأولوية للمشاة'
        }
      },
      {
        id: 'q-rr-8o2',
        text: {
          en: 'Continue driving, pedestrians must wait',
          nl: 'Blijf rijden, voetgangers moeten wachten',
          ar: 'استمر في القيادة، يجب على المشاة الانتظار'
        }
      },
      {
        id: 'q-rr-8o3',
        text: {
          en: 'Honk to warn the pedestrian',
          nl: 'Toeter om de voetganger te waarschuwen',
          ar: 'استخدم البوق لتحذير المشاة'
        }
      }
    ],
    correctAnswerId: 'q-rr-8o1',
    explanation: {
      en: 'When exiting a roundabout, you must give way to pedestrians who are waiting to cross or already crossing.',
      nl: 'Bij het verlaten van een rotonde moet je voorrang verlenen aan voetgangers die wachten om over te steken of al aan het oversteken zijn.',
      ar: 'عند الخروج من الدوار، يجب عليك إعطاء الأولوية للمشاة الذين ينتظرون العبور أو يعبرون بالفعل.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-9',
    text: {
      en: 'You are approaching a roundabout and see an emergency vehicle with flashing lights. What should you do?',
      nl: 'Je nadert een rotonde en ziet een hulpdienstvoertuig met knipperende lichten. Wat moet je doen?',
      ar: 'أنت تقترب من دوار وترى مركبة طوارئ بأضواء وامضة. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-9o1',
        text: {
          en: 'Give way to the emergency vehicle',
          nl: 'Geef voorrang aan het hulpdienstvoertuig',
          ar: 'أعط الأولوية لمركبة الطوارئ'
        }
      },
      {
        id: 'q-rr-9o2',
        text: {
          en: 'Enter the roundabout normally',
          nl: 'Rijd normaal de rotonde op',
          ar: 'ادخل الدوار بشكل طبيعي'
        }
      },
      {
        id: 'q-rr-9o3',
        text: {
          en: 'Stop completely before the roundabout',
          nl: 'Stop volledig voor de rotonde',
          ar: 'توقف تماما قبل الدوار'
        }
      }
    ],
    correctAnswerId: 'q-rr-9o1',
    explanation: {
      en: 'Emergency vehicles with flashing lights have priority. Give way to them before entering the roundabout.',
      nl: 'Hulpdienstvoertuigen met knipperende lichten hebben voorrang. Geef hen voorrang voordat je de rotonde oprijdt.',
      ar: 'مركبات الطوارئ ذات الأضواء الوامضة لها الأولوية. أعطهم الأولوية قبل دخول الدوار.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-10',
    text: {
      en: 'You are in a roundabout and want to make a U-turn. What should you do?',
      nl: 'Je bent op een rotonde en wilt een U-bocht maken. Wat moet je doen?',
      ar: 'أنت في دوار وتريد عمل منعطف على شكل U. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-10o1',
        text: {
          en: 'Signal right and exit at the next exit',
          nl: 'Geef richting aan rechts en rijd uit bij de volgende uitgang',
          ar: 'أشر يمينا واخرج عند المخرج التالي'
        }
      },
      {
        id: 'q-rr-10o2',
        text: {
          en: 'Signal left and continue around',
          nl: 'Geef richting aan links en ga door',
          ar: 'أشر يسارا واستمر في الدوران'
        }
      },
      {
        id: 'q-rr-10o3',
        text: {
          en: 'U-turns are not allowed in roundabouts',
          nl: 'U-bochten zijn niet toegestaan op rotondes',
          ar: 'المنعطفات على شكل U غير مسموحة في الدوارات'
        }
      }
    ],
    correctAnswerId: 'q-rr-10o2',
    explanation: {
      en: 'To make a U-turn in a roundabout, signal left and continue around the roundabout to exit at the same road you entered from.',
      nl: 'Om een U-bocht te maken op een rotonde, geef je links richting aan en ga je door rond de rotonde om uit te rijden bij dezelfde weg waar je binnenkwam.',
      ar: 'لعمل منعطف على شكل U في الدوار، أشر يسارا واستمر في الدوران حول الدوار للخروج من نفس الطريق الذي دخلت منه.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-11',
    text: {
      en: 'You are approaching a roundabout and see a large truck already in the roundabout. What should you do?',
      nl: 'Je nadert een rotonde en ziet een grote vrachtwagen die al op de rotonde rijdt. Wat moet je doen?',
      ar: 'أنت تقترب من دوار وترى شاحنة كبيرة موجودة بالفعل في الدوار. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-11o1',
        text: {
          en: 'Give way to the truck',
          nl: 'Geef voorrang aan de vrachtwagen',
          ar: 'أعط الأولوية للشاحنة'
        }
      },
      {
        id: 'q-rr-11o2',
        text: {
          en: 'Enter the roundabout, trucks must give way',
          nl: 'Rijd de rotonde op, vrachtwagens moeten voorrang verlenen',
          ar: 'ادخل الدوار، يجب على الشاحنات إعطاء الأولوية'
        }
      },
      {
        id: 'q-rr-11o3',
        text: {
          en: 'Honk to warn the truck driver',
          nl: 'Toeter om de vrachtwagenchauffeur te waarschuwen',
          ar: 'استخدم البوق لتحذير سائق الشاحنة'
        }
      }
    ],
    correctAnswerId: 'q-rr-11o1',
    explanation: {
      en: 'Large trucks in a roundabout have the same rights as other vehicles. You must give way to them before entering.',
      nl: 'Grote vrachtwagens op een rotonde hebben dezelfde rechten als andere voertuigen. Je moet hen voorrang verlenen voordat je binnenrijdt.',
      ar: 'الشاحنات الكبيرة في الدوار لها نفس الحقوق مثل المركبات الأخرى. يجب عليك إعطاء الأولوية لهم قبل الدخول.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-12',
    text: {
      en: 'You are in a roundabout and see a car trying to enter from your right. What should you do?',
      nl: 'Je bent op een rotonde en ziet een auto die probeert binnen te rijden van rechts. Wat moet je doen?',
      ar: 'أنت في دوار وترى سيارة تحاول الدخول من يمينك. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-12o1',
        text: {
          en: 'Give way to the entering car',
          nl: 'Geef voorrang aan de binnenrijdende auto',
          ar: 'أعط الأولوية للسيارة الداخلة'
        }
      },
      {
        id: 'q-rr-12o2',
        text: {
          en: 'Continue driving, you have priority',
          nl: 'Blijf rijden, je hebt voorrang',
          ar: 'استمر في القيادة، لديك الأولوية'
        }
      },
      {
        id: 'q-rr-12o3',
        text: {
          en: 'Honk to warn the entering car',
          nl: 'Toeter om de binnenrijdende auto te waarschuwen',
          ar: 'استخدم البوق لتحذير السيارة الداخلة'
        }
      }
    ],
    correctAnswerId: 'q-rr-12o2',
    explanation: {
      en: 'Once you are in a roundabout, you have priority over vehicles trying to enter. The entering vehicle must give way to you.',
      nl: 'Zodra je op een rotonde rijdt, heb je voorrang op voertuigen die proberen binnen te rijden. Het binnenrijdende voertuig moet jou voorrang verlenen.',
      ar: 'بمجرد أن تكون في الدوار، لديك الأولوية على المركبات التي تحاول الدخول. يجب على المركبة الداخلة إعطاء الأولوية لك.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-13',
    text: {
      en: 'You are approaching a roundabout and see a bus already in the roundabout. What should you do?',
      nl: 'Je nadert een rotonde en ziet een bus die al op de rotonde rijdt. Wat moet je doen?',
      ar: 'أنت تقترب من دوار وترى حافلة موجودة بالفعل في الدوار. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-13o1',
        text: {
          en: 'Give way to the bus',
          nl: 'Geef voorrang aan de bus',
          ar: 'أعط الأولوية للحافلة'
        }
      },
      {
        id: 'q-rr-13o2',
        text: {
          en: 'Enter the roundabout, buses must give way',
          nl: 'Rijd de rotonde op, bussen moeten voorrang verlenen',
          ar: 'ادخل الدوار، يجب على الحافلات إعطاء الأولوية'
        }
      },
      {
        id: 'q-rr-13o3',
        text: {
          en: 'Honk to warn the bus driver',
          nl: 'Toeter om de buschauffeur te waarschuwen',
          ar: 'استخدم البوق لتحذير سائق الحافلة'
        }
      }
    ],
    correctAnswerId: 'q-rr-13o1',
    explanation: {
      en: 'Buses in a roundabout have the same rights as other vehicles. You must give way to them before entering.',
      nl: 'Bussen op een rotonde hebben dezelfde rechten als andere voertuigen. Je moet hen voorrang verlenen voordat je binnenrijdt.',
      ar: 'الحافلات في الدوار لها نفس الحقوق مثل المركبات الأخرى. يجب عليك إعطاء الأولوية لهم قبل الدخول.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-14',
    text: {
      en: 'You are in a roundabout and want to exit but see a cyclist in the exit lane. What should you do?',
      nl: 'Je bent op een rotonde en wilt uitrijden maar ziet een fietser in de uitrijstrook. Wat moet je doen?',
      ar: 'أنت في دوار وتريد الخروج لكن ترى راكب دراجة في ممر الخروج. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-14o1',
        text: {
          en: 'Give way to the cyclist',
          nl: 'Geef voorrang aan de fietser',
          ar: 'أعط الأولوية لراكب الدراجة'
        }
      },
      {
        id: 'q-rr-14o2',
        text: {
          en: 'Exit normally, cyclists must give way',
          nl: 'Rijd normaal uit, fietsers moeten voorrang verlenen',
          ar: 'اخرج بشكل طبيعي، يجب على راكبي الدراجات إعطاء الأولوية'
        }
      },
      {
        id: 'q-rr-14o3',
        text: {
          en: 'Honk to warn the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتحذير راكب الدراجة'
        }
      }
    ],
    correctAnswerId: 'q-rr-14o1',
    explanation: {
      en: 'When exiting a roundabout, you must give way to cyclists who are already in the exit lane.',
      nl: 'Bij het verlaten van een rotonde moet je voorrang verlenen aan fietsers die al in de uitrijstrook rijden.',
      ar: 'عند الخروج من الدوار، يجب عليك إعطاء الأولوية لراكبي الدراجات الموجودين بالفعل في ممر الخروج.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-15',
    text: {
      en: 'You are approaching a roundabout and see a motorcycle already in the roundabout. What should you do?',
      nl: 'Je nadert een rotonde en ziet een motorfiets die al op de rotonde rijdt. Wat moet je doen?',
      ar: 'أنت تقترب من دوار وترى دراجة نارية موجودة بالفعل في الدوار. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-15o1',
        text: {
          en: 'Give way to the motorcycle',
          nl: 'Geef voorrang aan de motorfiets',
          ar: 'أعط الأولوية للدراجة النارية'
        }
      },
      {
        id: 'q-rr-15o2',
        text: {
          en: 'Enter the roundabout, motorcycles must give way',
          nl: 'Rijd de rotonde op, motorfietsen moeten voorrang verlenen',
          ar: 'ادخل الدوار، يجب على الدراجات النارية إعطاء الأولوية'
        }
      },
      {
        id: 'q-rr-15o3',
        text: {
          en: 'Honk to warn the motorcyclist',
          nl: 'Toeter om de motorrijder te waarschuwen',
          ar: 'استخدم البوق لتحذير راكب الدراجة النارية'
        }
      }
    ],
    correctAnswerId: 'q-rr-15o1',
    explanation: {
      en: 'Motorcycles in a roundabout have the same rights as other vehicles. You must give way to them before entering.',
      nl: 'Motorfietsen op een rotonde hebben dezelfde rechten als andere voertuigen. Je moet hen voorrang verlenen voordat je binnenrijdt.',
      ar: 'الدراجات النارية في الدوار لها نفس الحقوق مثل المركبات الأخرى. يجب عليك إعطاء الأولوية لهم قبل الدخول.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-16',
    text: {
      en: 'You are on a roundabout taking the second exit (straight ahead). After passing the first exit, you activate your right indicator. Why?',
      nl: 'Je rijdt op een rotonde en neemt de tweede afslag (rechtdoor). Na de eerste afslag zet je je rechter richtingaanwijzer aan. Waarom?',
      ar: 'أنت على دوّار تأخذ المخرج الثاني (بالاتجاه إلى الأمام). بعد أن تمر بالمخرج الأول، تُفعّل إشارة اليمين. لماذا؟'
    },
    options: [
      {
        id: 'q-rr-16o1',
        text: {
          en: 'To warn circulating traffic behind you that you exist',
          nl: 'Om het verkeer achter je te waarschuwen dat je er bent',
          ar: 'للتنبيه لحركة المرور داخل الدوّار خلفك أنك ستغادر'
        }
      },
      {
        id: 'q-rr-16o2',
        text: {
          en: 'To signal to other road users that you will be leaving the roundabout at the next exit',
          nl: 'Om aan andere weggebruikers te signaleren dat je het rondpunt bij de volgende afslag verlaat',
          ar: 'لإعلام باقي مستخدمي الطريق أنك ستغادر الدوّار في المخرج التالي'
        }
      },
      {
        id: 'q-rr-16o3',
        text: {
          en: 'The right indicator is only used when turning right before the roundabout',
          nl: 'De rechter richtingaanwijzer wordt alleen gebruikt wanneer je vlak voor de rotonde rechtsaf gaat',
          ar: 'إشارة اليمين تُستخدم فقط عند الانعطاف يمينًا قبل الدوّار'
        }
      }
    ],
    correctAnswerId: 'q-rr-16o2',
    explanation: {
      en: 'Activating the right indicator after passing the previous exit signals your intention to leave the roundabout. This helps drivers at the upcoming entry know you are about to exit.',
      nl: 'Als je de rechter richtingaanwijzer inschakelt nadat je de vorige afslag bent gepasseerd, laat je zien dat je van plan bent de rotonde te verlaten. Dit helpt bestuurders bij de komende inrit te begrijpen dat je gaat uitrijden.',
      ar: 'يؤدي تفعيل إشارة اليمين بعد المرور بالمخرج السابق إلى إظهار نيتك في مغادرة الدوّار. وهذا يساعد السائقين عند المدخل التالي على فهم أنك على وشك الخروج.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-17',
    text: {
      en: 'On a two-lane roundabout, you are in the right lane. You realise you need an exit that requires the left lane. What should you do?',
      nl: 'Op een rotonde met twee rijstroken rijd je in de rechterrijstrook. Je realiseert dat je een afslag nodig hebt waarvoor je de linkerrijstrook moet gebruiken. Wat moet je doen?',
      ar: 'في دوّار من حارتين، أنت في الحارة اليمنى. تدرك أنك تحتاج إلى مخرج يتطلب الحارة اليسرى. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-rr-17o1',
        text: {
          en: 'Change lanes on the roundabout if it is safe to do so',
          nl: 'Wissel van rijstrook op de rotonde als dat veilig kan',
          ar: 'غيّر الحارات داخل الدوّار إذا كان ذلك آمنًا'
        }
      },
      {
        id: 'q-rr-17o2',
        text: {
          en: 'Continue to your exit in the right lane and adjust on the next pass, or take a different exit and re-approach',
          nl: 'Blijf doorrijden tot je afslag in de rechterrijstrook en corrigeer bij een volgende ronde, of neem een andere afslag en rijd opnieuw aan',
          ar: 'تابع إلى مخرجك في الحارة اليمنى ثم عدّل في المرة التالية، أو خذ مخرجًا آخر ثم أعد الدخول مرة ثانية'
        }
      },
      {
        id: 'q-rr-17o3',
        text: {
          en: 'Stop on the roundabout and wait for a gap to change lanes',
          nl: 'Stop op de rotonde en wacht op een opening om van rijstrook te wisselen',
          ar: 'توقف داخل الدوّار وانتظر وجود فجوة لتغيير الحارات'
        }
      }
    ],
    correctAnswerId: 'q-rr-17o2',
    explanation: {
      en: 'You should use the correct lane before entering the roundabout. Changing lanes on a busy roundabout is dangerous. The safest option is to continue and re-approach the roundabout in the correct lane.',
      nl: 'Je moet de juiste rijstrook gebruiken voordat je de rotonde oprijdt. Van rijstrook wisselen op een drukke rotonde is gevaarlijk. De veiligste optie is om door te rijden en de rotonde opnieuw te benaderen via de juiste rijstrook.',
      ar: 'يجب عليك استخدام الحارة الصحيحة قبل الدخول إلى الدوّار. تغيير الحارات في دوّار مزدحم أمر خطير. الخيار الأكثر أماناً هو الاستمرار ثم العودة إلى الدوّار من جديد في الحارة الصحيحة.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-18',
    text: {
      en: 'A yellow car approaches the haaientanden at a roundabout entry. A blue car is circulating. The yellow car\'s driver thinks they arrived first. Who has priority?',
      nl: 'Een gele auto komt de haaientanden bij een rotonde-inrit op. Een blauwe auto rijdt al op de rotonde. De bestuurder van de gele auto denkt dat ze als eerste zijn aangekomen. Wie heeft voorrang?',
      ar: 'تقترب سيارة صفراء من هاعاينتانـدن في مدخل الدوّار. توجد سيارة زرقاء داخل الدوّار وتدور فيه. يعتقد سائق السيارة الصفراء أنه وصل أولاً. من له الأولوية؟'
    },
    options: [
      {
        id: 'q-rr-18o1',
        text: {
          en: 'The yellow car because it arrived at the roundabout first',
          nl: 'De gele auto omdat die als eerste bij de rotonde was',
          ar: 'السيارة الصفراء لأنها وصلت إلى الدوّار أولاً'
        }
      },
      {
        id: 'q-rr-18o2',
        text: {
          en: 'The blue circulating car; arrival order is irrelevant at roundabouts',
          nl: 'De blauwe auto op de rotonde; aankomstvolgorde doet er niet toe op rotondes',
          ar: 'السيارة الزرقاء داخل الدوّار؛ ترتيب الوصول لا يهم في الدوّارات'
        }
      },
      {
        id: 'q-rr-18o3',
        text: {
          en: 'Whichever car is larger',
          nl: 'Welke auto het grootst is',
          ar: 'أي سيارة أكبر حجماً'
        }
      }
    ],
    correctAnswerId: 'q-rr-18o2',
    explanation: {
      en: 'Priority on a Dutch roundabout is determined by position, not arrival time. Traffic already on the roundabout always has priority over entering traffic at haaientanden. (RVV 1990 art. 80)',
      nl: 'Voorrang op een Nederlandse rotonde wordt bepaald door positie, niet door aankomsttijd. Verkeer dat al op de rotonde rijdt heeft altijd voorrang boven verkeer dat wil inrijden bij de haaientanden. (RVV 1990 art. 80)',
      ar: 'تُحدد الأولوية في الدوّار الهولندي حسب الموقع وليس حسب وقت الوصول. حركة المرور الموجودة داخل الدوّار دائماً لها الأولوية على المركبات التي تدخل من عند هاعاينتانـدن. (قانون المرور الهولندي 1990، المادة 80)'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-19',
    text: {
      en: 'A car is circulating on a roundabout. A driver enters without giving way, forcing the circulating car to brake. Who is at fault?',
      nl: 'Een auto rijdt al op de rotonde. Een bestuurder rijdt in zonder voorrang te verlenen, waardoor de auto op de rotonde moet remmen. Wie is schuldig?',
      ar: 'توجد سيارة تدور في الدوّار. يدخل سائق دون أن يعطي أولوية، مما يجبر السيارة التي كانت تدور على الكبح. من المخطئ؟'
    },
    options: [
      {
        id: 'q-rr-19o1',
        text: {
          en: 'The circulating driver for not leaving enough room',
          nl: 'De bestuurder op de rotonde omdat die niet genoeg ruimte liet',
          ar: 'السائق الموجود داخل الدوّار لأنه لم يترك مساحة كافية'
        }
      },
      {
        id: 'q-rr-19o2',
        text: {
          en: 'The entering driver for not giving way at the haaientanden',
          nl: 'De bestuurder die inrijdt omdat die geen voorrang gaf bij de haaientanden',
          ar: 'السائق الداخل لأنه لم يعطِ أولوية عند هاعاينتانـدن'
        }
      },
      {
        id: 'q-rr-19o3',
        text: {
          en: 'Neither; it is a shared fault',
          nl: 'Geen van beiden; het is gedeelde schuld',
          ar: 'لا هذا ولا ذاك؛ مسؤولية مشتركة'
        }
      }
    ],
    correctAnswerId: 'q-rr-19o2',
    explanation: {
      en: 'The entering driver is at fault. The haaientanden markings place the give-way obligation entirely on the entering driver. Circulating traffic has right of way. (RVV 1990 art. 80)',
      nl: 'De bestuurder die inrijdt is schuldig. De haaientanden-markeringen leggen de verplichting om voorrang te verlenen volledig bij de bestuurder die inrijdt. Verkeer dat al op de rotonde rijdt heeft voorrang. (RVV 1990 art. 80)',
      ar: 'السائق الداخل هو المخطئ. إن علامات هاعاينتانـدن تجعل التزام إعطاء الأولوية بالكامل على السائق الداخل. حركة المرور داخل الدوّار لها حق المرور. (قانون المرور الهولندي 1990، المادة 80)'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-20',
    text: {
      en: 'You are driving straight on (second exit) at a roundabout. You pass the first exit and activate your right indicator. A driver at the next entry sees your indicator. What do they understand?',
      nl: 'Je rijdt rechtdoor (tweede afslag) op een rotonde. Je passeert de eerste afslag en zet je rechter richtingaanwijzer aan. Een bestuurder bij de volgende inrit ziet je richtingaanwijzer. Wat begrijpen ze?',
      ar: 'أنت تسير مباشرة (المخرج الثاني) في دوّار. بعد أن تمر بالمخرج الأول، تُفعّل إشارة اليمين. سائق عند المدخل التالي يرى إشارة اليمين الخاصة بك. ماذا يفهمون؟'
    },
    options: [
      {
        id: 'q-rr-20o1',
        text: {
          en: 'You are turning right and leaving the roundabout at the next exit',
          nl: 'Je slaat rechtsaf en verlaat de rotonde bij de volgende afslag',
          ar: 'أنت تنعطف يميناً وتغادر الدوّار في المخرج التالي'
        }
      },
      {
        id: 'q-rr-20o2',
        text: {
          en: 'You are going faster and they should move aside',
          nl: 'Je gaat sneller en ze moeten uit de weg gaan',
          ar: 'أنت تقود أسرع وعليهم أن يتحركوا جانباً'
        }
      },
      {
        id: 'q-rr-20o3',
        text: {
          en: 'Your indicator has come on by accident',
          nl: 'Je richtingaanwijzer is per ongeluk aangegaan',
          ar: 'إشارة الانعطاف الخاصة بك ظهرت بالخطأ'
        }
      }
    ],
    correctAnswerId: 'q-rr-20o1',
    explanation: {
      en: 'A right indicator on a roundabout signals that you are about to exit. Drivers at the upcoming entry can use this information to judge when to enter safely.',
      nl: 'Een rechter richtingaanwijzer op een rotonde geeft aan dat je gaat uitrijden. Bestuurders bij de komende inrit kunnen deze informatie gebruiken om in te schatten wanneer ze veilig kunnen inrijden.',
      ar: 'تُشير إشارة اليمين في الدوّار إلى أنك على وشك مغادرته. يمكن للسائقين عند المدخل القادم استخدام هذه المعلومة لتقدير الوقت المناسب للدخول بأمان.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-21',
    questionType: 'yesno',
    yesNoMapping: { yes: 'q-rr-21o2', no: 'q-rr-21o1' },
    text: {
      en: 'When approaching a roundabout, should you reduce your speed?',
      nl: 'Moet je je snelheid verlagen wanneer je een rotonde nadert?',
      ar: 'عند الاقتراب من دوّار، هل يجب أن تُقلّل سرعتك؟'
    },
    options: [
      {
        id: 'q-rr-21o1',
        text: {
          en: 'No, you should maintain your speed and only slow if traffic blocks you',
          nl: 'Nee, je moet je snelheid aanhouden en alleen verminderen als het verkeer je blokkeert',
          ar: 'لا؛ حافظ على سرعتك ولا تُبطئ إلا إذا كانت حركة المرور تعيقك'
        }
      },
      {
        id: 'q-rr-21o2',
        text: {
          en: 'Yes, reduce speed to check for circulating traffic and be able to give way safely',
          nl: 'Ja, verlaag je snelheid om het verkeer op de rotonde te controleren en veilig voorrang te kunnen verlenen',
          ar: 'نعم، قلّل السرعة للتأكد من حركة المرور داخل الدوّار وأن تكون قادرًا على إعطاء الأولوية بأمان'
        }
      },
      {
        id: 'q-rr-21o3',
        text: {
          en: 'Only if there is a speed limit sign at the entry',
          nl: 'Alleen als er bij de inrit een bord met snelheidslimiet staat',
          ar: 'فقط إذا كانت هناك علامة حد سرعة عند المدخل'
        }
      }
    ],
    correctAnswerId: 'q-rr-21o2',
    explanation: {
      en: 'Always reduce speed when approaching a roundabout. You need to observe circulating traffic, be prepared to give way at the haaientanden, and enter at a speed that is safe for the roundabout.',
      nl: 'Verminder altijd je snelheid wanneer je een rotonde nadert. Je moet het verkeer op de rotonde observeren, klaar zijn om voorrang te verlenen bij de haaientanden en de rotonde inrijden met een snelheid die veilig is voor de rotonde.',
      ar: 'قلّل السرعة دائمًا عند الاقتراب من دوّار. يجب عليك مراقبة حركة المرور داخل الدوّار، والاستعداد لإعطاء الأولوية عند هاعاينتانـدن، والدخول بسرعة تكون آمنة بالنسبة للدوّار.'
    },
    subject: 'Roundabout Rules'
  },
  {
    id: 'q-rr-22',
    text: {
      en: 'You are exiting a roundabout. There is a cyclist in the fietspad who is not yet at the crossing. Do you still have to give way?',
      nl: 'Je verlaat een rotonde. Er is een fietser op het fietspad die nog niet bij de oversteek is. Moet je nog steeds voorrang geven?',
      ar: 'أنت تغادر دوّاراً. يوجد درّاج داخل مسار الدراجات لكنه ليس عند نقطة العبور بعد. هل ما زال عليك إعطاء الأولوية؟'
    },
    options: [
      {
        id: 'q-rr-22o1',
        text: {
          en: 'No, only give way when the cyclist is actually on the crossing',
          nl: 'Nee, geef alleen voorrang als de fietser zich echt op de oversteek bevindt',
          ar: 'لا، لا تعطي الأولوية إلا عندما يكون الدراج فعلاً عند نقطة العبور'
        }
      },
      {
        id: 'q-rr-22o2',
        text: {
          en: 'Yes, if the cyclist is approaching and close enough that stopping is safe and necessary',
          nl: 'Ja, als de fietser nadert en dicht genoeg is zodat stoppen veilig en nodig is',
          ar: 'نعم، إذا كان الدراج قادمًا ومقربًا بما يكفي بحيث يكون التوقف آمنًا وضروريًا'
        }
      },
      {
        id: 'q-rr-22o3',
        text: {
          en: 'Only if the cyclist signals with their hand',
          nl: 'Alleen als de fietser met de hand aangeeft',
          ar: 'فقط إذا كان الدراج يشير بيده'
        }
      }
    ],
    correctAnswerId: 'q-rr-22o2',
    explanation: {
      en: 'You must give way to cyclists in or about to use the fietspad crossing at the roundabout exit. If a cyclist is approaching and it is clear they intend to cross, you must yield before they reach the crossing. (RVV 1990 art. 49)',
      nl: 'Je moet voorrang verlenen aan fietsers die zich in de buurt bevinden of die gebruik gaan maken van de oversteek op het fietspad bij de uitrit van de rotonde. Als een fietser nadert en duidelijk is dat hij/zij van plan is over te steken, moet je voorrang verlenen voordat ze de oversteek bereiken. (RVV 1990 art. 49)',
      ar: 'يجب عليك إعطاء الأولوية للدراجين الموجودين أو الذين على وشك استخدام تقاطع مسار الدراجات عند مخرج الدوّار. إذا كان الدراج قادمًا وكان واضحًا أنه يعتزم العبور، فعليك أن تعطيه الأولوية قبل أن يصل إلى نقطة العبور. (قانون المرور الهولندي 1990، المادة 49)'
    },
    subject: 'Roundabout Rules'
  }
];

























